export default __webpack_public_path__ + "static/launchpad-f0145dc7dcb2f3fe93769e6b580b8a4a.webp";